module.exports = ".title-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.chart-controls {\n  margin-right: 10px;\n}\n.chart-controls button {\n  color: #2196f3;\n  background: none;\n  border: none;\n  outline: none;\n}\n.chart-controls button:hover {\n  color: #1582d8;\n  background: #ededed;\n}\n.spacer {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/model/model-chart-container/model-chart-container.component.less
// module id = ./src/app/projects/model/model-chart-container/model-chart-container.component.less
// module chunks = main